import { format, utcToZonedTime } from 'date-fns-tz';

export interface EventDateAndTimeI {
	testEventDate: string;
	startTime: string;
	endTime: string;
}

interface EventDateAndTimeCTI {
	testEventDateCT: string;
	startTimeCT: string;
	endTimeCT: string;
}

export class Helper {
	timezome: string;

	constructor() {
		this.timezome = 'America/Chicago';
	}

	getCTTime(dateTime: EventDateAndTimeI): EventDateAndTimeCTI {
		const { testEventDate, startTime, endTime } = dateTime;

		// Get the CT offset for the selected date
		const selectedDate = new Date(testEventDate);
		const ctOffset = this.getCTOffset(selectedDate); // e.g., '-05:00' or '-06:00'

		// Combine date and time in CT with dynamic offset
		const startDateTimeCT = `${testEventDate}T${startTime}:00${ctOffset}`; // 10:00 AM CT
		const endDateTimeCT = `${testEventDate}T${endTime}:00${ctOffset}`; // 11:30 AM CT

		// Format the date and time in ISO format (CT)
		const testEventDateCT = new Date(startDateTimeCT).toISOString(); // 2025-03-28T10:00:00.000Z (CT)

		const startTimeCT = startDateTimeCT; // 2025-03-28T10:00:00-05:00 (CT)
		const endTimeCT = endDateTimeCT; // 2025-03-28T11:30:00-05:00 (CT)

		return {
			testEventDateCT,
			startTimeCT,
			endTimeCT
		};
	}

	// Helper function to get the CT offset for a given date
	getCTOffset(date: Date): string {
		const zonedTime = utcToZonedTime(date, this.timezome); // Convert UTC to CT
		const offset = format(zonedTime, 'XXX', { timeZone: this.timezome }); // Get the offset (e.g., '-05:00' or '-06:00')
		return offset;
	}

	formatCTTime(time: string): string {
		// Convert the test event date to Central Time (CT)
		const eventDateCT = utcToZonedTime(time, this.timezome);

		// Format the date for display
		return format(eventDateCT, 'h:mm a');
	}
}